<template>
    <div ref="vueblock" class="vue-block" v-bind:class="[{ active: toggle, 'full-screen': fullscreen}, classname ]">
      <slot class="block-content">
      </slot>
    </div>
</template>

<script>
export default {
  name: "vue-block",
  props: {
    classname: String,    
    toggle: Boolean,
    fullscreen: Boolean,    
  }
};
</script>

<style lang="scss" scoped>
  .vue-block {
    display: none;
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.9);

    &.active {
      display: flex;  
    }

    &.full-screen {
      position: fixed;
    }
  }  
</style>